export default __webpack_public_path__ + "static/media/lines-no-2.33ebf3bc.mid";